import { Injectable } from '@angular/core';
import { AppConfigService } from '../../auth/services/app-config.service';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface ResponseData {
  label: string,
  data: string,
}

interface BulkStatus {
  id: number,
  categoryId: number,
  poisCount: number,
  status: string,
  message: string,
  createdAt: string,
  updatedAt: string | null,
  deletedAt: string | null
}

@Injectable({
  providedIn: 'root'
})
export class PointsOfInterestService {

  private backendUrl: string =  `${this.appConfig.config.baseUrl}${this.appConfig.config.backendUrl}`;

  private handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  constructor( private http: HttpClient, private appConfig: AppConfigService) { }
  
  bulkPois(id: number, formData: any): Observable<BulkStatus> {
    let headers = new HttpHeaders();
    headers.set('Content-Type', '');

    return this.http
      .post<BulkStatus>(
        `${this.backendUrl}/pois/bulk2/${id}`,
        formData,
        {headers: headers},
      ).pipe(
        catchError(this.handleError)
      );
  }
  sendPoisToMove(data: [any]): Observable<any> {
    return this.http.put(
      `${this.backendUrl}/pois/movecategory`,
      data,
      {observe: 'response'},
    ).pipe(
      catchError(this.handleError)
    );
  }

  addPois(pois: any): Observable<any> {
    return this.http
      .post<ResponseData>(
        `${this.backendUrl}/pois`,
        pois,
        {observe: 'response'},
      ).pipe(
        catchError(this.handleError)
      );
  }

  editPois(pois: any): Observable<any> {
    return this.http
      .put(
        `${this.backendUrl}/pois`,
        pois,
        {observe: 'response'},
      ).pipe(
        catchError(this.handleError)
      );
  }
}